module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-thinking.107a5801.png";